import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuViewportElement,
  type TNavigationMenuViewportProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuViewport = forwardRef<
  TNavigationMenuViewportElement,
  TNavigationMenuViewportProps
>(({ className, ...props }, ref) => (
  <div className="absolute left-0 top-full flex justify-center perspective-[2000px]">
    <NavigationMenuPrimitive.Viewport
      ref={ref}
      data-component="NavigationMenuViewport"
      className={cn(
        "relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-sys-sm border border-solid border-component-navigation-menu-viewport bg-component-dropdownMenu-viewport shadow-sm",
        "origin-top-center data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90",
        "md:w-[var(--radix-navigation-menu-viewport-width)]",
        className,
      )}
      {...props}
    />
  </div>
));

NavigationMenuViewport.displayName = NavigationMenuPrimitive.Viewport.displayName;
